const NeoVisConfig = 
{
  container_id: "viz",
  server_url: process.env.VUE_APP_BOLT_URL,
  server_user: process.env.VUE_APP_NEO4J_USER,
  server_password: process.env.VUE_APP_NEO4J_PASSWORD,
  encrypted: "ENCRYPTION_ON",
  labels: {
    "Account": {
      "caption": "screen_name"
    },
    "Hashtag": {
      "caption": "hashtag"
    },
    "Status": {
      "caption": false
    },
    "Url": {
      "caption": "url"
    }
  },
  relationships: {
    "HASHTAG": {
      "caption": true,
    },
    "HASHTAG_OF": {
      "caption": true,
    },
    "MENTION": {
      "caption": true,
    },
    "MENTIONED_BY": {
      "caption": true,
    },
    "POSTED": {
      "caption": true,
    },
    "POSTED_BY": {
      "caption": true,
    },
    "RETWEET": {
      "caption": true,
    },
    "RETWEETED": {
      "caption": true,
    },
    "RETWEETED_BY": {
      "caption": true,
    },
    "RETWEET_OF": {
      "caption": true,
    },
    "URL": {
      "caption": true,
    },
    "URL_OF": {
      "caption": "url_of",
    }    
  },
  initial_cypher: ""
}

export default NeoVisConfig;